export default "__VITE_ASSET__DMuFzGRP__"